<script>
import logo from '../partials/components/logo.vue';
import animation from '../partials/components/animate.vue';
import slider from '../partials/modules/slider.vue';
import slide from '../partials/components/slide.vue';
import Slick from 'vue-slick';

export default {
    components: { logo, animation, Slick },
    data() {
        return {
            slickOptions: {
                slidesToShow: 1,
                infinite: true,
                centerMode: true,
                centerPadding: '0%',
                accessibility: true,
                adaptiveHeight: false,
                arrows: false,
                dots: false,
                draggable: true,
                fade: true,
                autoplay: false,
                autoplaySpeed: 4000,
                pauseOnHover: false,
                cssEase: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)'
            },
            coverFinished: false
        };
    },

    mounted() {
        this.$refs.coverLogo.classList.remove('opacity-0');
    },

    methods: {
        coverOut() {
            const getOuttaHere = greensock.timeline();

            getOuttaHere
                .to(this.$refs.coverLogo, {
                    opacity: 0,
                    duration: 0.8,
                    delay: 1,
                    ease: 'circ.inOut'
                })
                .to(this.$refs.coverSlice01, {
                    y: '-100%',
                    duration: 0.8,
                    delay: -0.2,
                    ease: 'circ.inOut'
                })
                .to(this.$refs.coverSlice02, {
                    y: '100%',
                    duration: 0.8,
                    delay: -0.8,
                    ease: 'circ.inOut'
                })
                .to(this.$refs.coverSlice03, {
                    y: '-100%',
                    duration: 0.8,
                    delay: -0.8,
                    ease: 'circ.inOut',
                    onComplete: this.removeCover
                });
        },

        removeCover() {
            this.coverFinished = true;
            this.$refs.slick.play();
        },

        next() {
            this.$refs.slick.next();
        },
        prev() {
            this.$refs.slick.prev();
        },
        reInit() {
            this.$refs.slick.reSlick();
        }
    }
};
</script>
